export const TripTypeConfig=[{
    id:'personal',
    label:'Personal'
  },
  {
    id:'business',
    label:'Business'
  
  }]
  export const PROMO_DISPLAY_COUNT= 3;